"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const file_1 = require("../file");
const postVehicleExpirationImage = ({ axios, imageFile }) => file_1.postFile({
    axios,
    bucket: "vehicle-expiration-images",
    file: imageFile
});
exports.default = postVehicleExpirationImage;
